import RequestBehaviour from '../base/RequestBehaviour';

export default class StatusTransaction extends RequestBehaviour {
	/**
	 * Payment UUID
	 */
	payment_uuid?: string = undefined;
}
